import { useFullRemoteTheme } from '@eduzz/ui-antd-theme';

import { cn } from '@/lib/cn';

import LogoFallback from '../icons/Logo';

/** Key under `remoteTheme.logos` holding this application's brand assets. */
const LOGO_APPLICATION = 'eduzz';

const ALT = 'Eduzz';

type LogoProps = {
  className?: string;
};

/**
 * Brand logo served from the remote theme CDN, so a rebrand ships without a deploy.
 * Light/dark selection is done in CSS rather than JS to stay in sync with the
 * `data-eduzz-theme` attribute that drives every other `dark:` utility.
 */
const Logo = ({ className }: LogoProps) => {
  const logos = useFullRemoteTheme()?.logos?.[LOGO_APPLICATION];

  if (!logos) {
    return <LogoFallback className={className} />;
  }

  return (
    <>
      <img src={logos.logo} alt={ALT} className={cn('object-contain dark:hidden', className)} />
      <img src={logos.logoDarkMode} alt={ALT} className={cn('hidden object-contain dark:block', className)} />
    </>
  );
};

export default Logo;
